import {Component, inject} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import {AuthenticationService} from '../../../../services/auth/authentication.service';
import {MessageService} from 'primeng/api';
import {RestErrorHelper} from '../../../../helper/rest-error-helper';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {AdminService} from '../../../../services/admin.service';
import {MandantAdminService} from '../../mandant-admin-module/services/mandant-admin.service';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { Button } from 'primeng/button';
import {PlayerProfileService} from '../../../player/service/player-profile.service';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: true,
    imports: [FormsModule, InputTextModule, MessageModule, Button, TranslatePipe]
})
export class ChangePasswordComponent
{
  private playerProfileService = inject(PlayerProfileService);
  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);
  private translate = inject(TranslateService);
  private authenticationService = inject( AuthenticationService);
  private messageService = inject(MessageService);
  private adminService = inject(AdminService);
  private mandantAdminService = inject(MandantAdminService);
  private restErrorHelper = inject(RestErrorHelper);

  playerProfile: boolean;

  requireOldPassword: boolean;
  passwordNew: string;
  passwordRetype: string;
  passwordOld: string;
  mandantAdmin: boolean;
  passwordMinLength = environment.minPasswordLength;

  errorMsg: string;
  isLoading: boolean;
  username: string;

  constructor()
  {
    this.requireOldPassword = true;
    if (this.config.data)
    {
      this.playerProfile = this.config.data.playerProfile;
      if (this.config.data.noOldPassword)
        this.requireOldPassword = false;
      this.username = this.config.data.username;
      this.mandantAdmin = this.config.data.mandantAdmin;
    }

    if (this.playerProfile)
      this.passwordMinLength = environment.minPasswordLengthPlayer;
  }

  public changePassword(): void
  {
    this.errorMsg = '';

    if (this.passwordNew !== this.passwordRetype)
    {
      this.errorMsg = this.translate.instant('PASSWORDS_NOT_MATCHING');
      return;
    }
    if (this.passwordNew.length < this.passwordMinLength)
    {
      this.errorMsg = this.translate.instant('PASSWORD_DOES_NOT_MATCH_GUIDELINES');
      return;
    }

    this.isLoading = true;
    if (this.playerProfile)
    {
      this.playerProfileService.changePassword(this.passwordNew, this.passwordOld).subscribe({
        next: () => this.passwordChangedSuccessfully(),
        error: error => this.passwordChangeError(error)
      });
    }
    else if (this.mandantAdmin)
    {
      this.mandantAdminService.changePassword(this.passwordNew, this.username).subscribe({
        next: () => this.passwordChangedSuccessfully(),
        error: error => this.passwordChangeError(error)
      });
    }
    else
    {
      if (this.authenticationService.admin && !this.requireOldPassword)
      {
        this.adminService.changePassword(this.passwordNew, this.username).subscribe({
          next: () => this.passwordChangedSuccessfully(),
          error: error => this.passwordChangeError(error)
        });
      }
      else
      {
        this.authenticationService.changePasswordWithOldPassword(this.passwordNew, this.passwordOld,
          this.authenticationService.username).subscribe({
          next: () => this.passwordChangedSuccessfully(),
          error: error => this.passwordChangeError(error)
        });
      }
    }
  }

  private passwordChangedSuccessfully(): void
  {
    console.log('Passwort erfolgreich geändert.');
    this.isLoading = false;
    this.messageService.add({
      severity: 'success',
      summary: this.translate.instant('PASSWORD_CHANGED_SUCCESS'),
      life: environment.toastDurationShort
    });
    this.ref.close(true);
  }

  private passwordChangeError(error: any): void
  {
    console.log('error', error);
    this.errorMsg = this.restErrorHelper.getErrorStr(error);
    this.isLoading = false;
  }
}
